import { css } from 'styled-components/native';

export const brandSpecificNavBorderStyle = css``;
